import apiClient from './client';
const storeTokens = (tokens) => {
    localStorage.setItem('auth_tokens', JSON.stringify(tokens));
};
export const authApi = {
    async login(credentials) {
        const response = await apiClient.post('/v1/admin/auth/login', credentials);
        // Check if 2FA is required
        if (response.data.data.requires2FA) {
            return {
                requires2FA: true,
                userId: response.data.data.userId,
                tokens: { accessToken: '', refreshToken: '' },
                user: {},
            };
        }
        // Store tokens in the format expected by the client
        storeTokens({
            accessToken: response.data.data.access_token,
            refreshToken: response.data.data.refresh_token,
        });
        // Return in the format expected by the UI
        return {
            tokens: {
                accessToken: response.data.data.access_token,
                refreshToken: response.data.data.refresh_token,
            },
            user: response.data.data.user,
        };
    },
    async complete2FALogin(userId, token) {
        const response = await apiClient.post('/v1/admin/auth/login/2fa', { userId, token });
        // Store tokens
        storeTokens({
            accessToken: response.data.data.access_token,
            refreshToken: response.data.data.refresh_token,
        });
        return {
            tokens: {
                accessToken: response.data.data.access_token,
                refreshToken: response.data.data.refresh_token,
            },
            user: response.data.data.user,
        };
    },
    async signup(data) {
        const response = await apiClient.post('/v1/admin/auth/signup', data);
        storeTokens({
            accessToken: response.data.data.access_token,
            refreshToken: response.data.data.refresh_token,
        });
        return {
            tokens: {
                accessToken: response.data.data.access_token,
                refreshToken: response.data.data.refresh_token,
            },
            user: response.data.data.user,
        };
    },
    async logout() {
        try {
            await apiClient.post('/v1/admin/auth/logout');
        }
        finally {
            localStorage.removeItem('auth_tokens');
        }
    },
    async getCurrentUser() {
        const response = await apiClient.get('/v1/admin/auth/me');
        return response.data.data.user;
    },
    isAuthenticated() {
        const tokens = localStorage.getItem('auth_tokens');
        return !!tokens;
    },
};
